<template>
    <div class="callWidget">
        <div class="callWidgetTop">
            <div
                :class="{
                    callWidgetTop__title: true,
                    'callWidgetTop__title--revert': hasIncoming,
                }"
            >
                <img :src="`${$window.Config.cdn_url}/images/app/svg/arrow-top-right.svg`" alt="" />
                <span v-if="hasIncoming">Incoming</span>
                <span v-else>Outgoing Call</span>
            </div>

            <div class="callWidgetTop__right">
                <div v-if="showRollup" class="callWidgetTop__time">
                    {{ formattedTime }}
                </div>
                <div v-if="hasConnectOpen" :class="classesRollup" @click="handleRollup" />
            </div>
        </div>

        <template v-if="!showRollup">
            <template v-if="activeKeypad">
                <call-key-pad @change="handleChangeKeyPad" />
            </template>
            <template v-else>
                <template v-if="conferenceSid && conferenceCallingParticipants.length">
                    <div class="callWidgetInfoList">
                        <div
                            v-for="(participant, index) in conferenceCallingParticipants"
                            :key="index"
                            class="callWidgetInfo"
                            :class="{
                                'callWidgetInfo--onHold':
                                    ['loading', 'hold'].includes(participant.status) ||
                                    isHoldConferenceCalling,
                                'callWidgetInfo--clickable': true,
                            }"
                        >
                            <template v-if="participant.hasOwnProperty('contact')">
                                <div class="callWidgetInfo__image">
                                    <avatar :size="30" :contact="participant.contact" />
                                </div>
                                <div class="callWidgetInfo__box">
                                    <div
                                        v-if="participant.contact.name"
                                        class="callWidgetInfo__title"
                                    >
                                        {{ participant.contact.name }}
                                    </div>
                                    <div
                                        v-if="participant.contact.formatted_number"
                                        class="callWidgetInfo__number"
                                    >
                                        {{ participant.contact.formatted_number }}
                                    </div>
                                </div>
                                <div
                                    v-if="participant.status !== 'calling'"
                                    class="callWidgetInfo__actions"
                                >
                                    <div
                                        class="callWidgetInfo__actions--button"
                                        :class="{
                                            '--disabled': isHoldConferenceCalling,
                                        }"
                                        @click="handleChangeParticipantStatus(participant)"
                                    >
                                        <basic-loader
                                            v-if="participant.status === 'loading'"
                                            :center="true"
                                            aria-label="CallWidget"
                                        />
                                        <template v-else>
                                            <vector-icon
                                                v-if="
                                                    participant.status === 'hold' ||
                                                        isHoldConferenceCalling
                                                "
                                                icon="play-icon"
                                            />
                                            <vector-icon v-else icon="pause-icon" />
                                        </template>
                                    </div>
                                    <div
                                        class="callWidgetInfo__actions--button"
                                        @click="handleParticipantCallEnd(participant)"
                                    >
                                        <basic-loader
                                            v-if="participant.status === 'deletion'"
                                            :center="true"
                                            aria-label="CallWidget"
                                        />
                                        <vector-icon v-else icon="call-end" :size="[18, 9]" />
                                    </div>
                                </div>
                                <div
                                    v-if="participant.status === 'calling'"
                                    class="callWidgetInfo__status"
                                >
                                    Calling...
                                </div>
                            </template>
                            <template v-else-if="participant.hasOwnProperty('inbox')">
                                <div class="callWidgetInfo__image">
                                    <template>
                                        <avatar
                                            v-if="participant.inbox.isAircallNumber"
                                            :contact="{
                                                photo_url: `${$window.Config.cdn_url}/images/app/integrations/aircall.png`,
                                            }"
                                            :size="30"
                                        />
                                        <template v-else>
                                            <avatar
                                                v-if="participant.inbox.hasOwnProperty('teams')"
                                                :contact="{
                                                    photo_url: `${$window.Config.cdn_url}/images/app/svg/inbox_group.svg`,
                                                }"
                                                :size="30"
                                            />
                                            <avatar
                                                v-else-if="participant.inbox.id"
                                                :useVectorIcon="participant.inbox.is_smart"
                                                :contact="{
                                                    first_name: participant.inbox.name,
                                                    color: participant.inbox.color,
                                                    fill: participant.inbox.is_smart
                                                        ? 'white'
                                                        : participant.inbox.color,
                                                    icon: participant.inbox.is_smart
                                                        ? 'smart-inbox'
                                                        : null,
                                                }"
                                                :sizeIcon="30 / 2"
                                                :size="30"
                                            />
                                            <avatar
                                                v-else-if="participant.inbox.id === null"
                                                :contact="{
                                                    photo_url: `${$window.Config.cdn_url}/images/app/svg/all_inboxes.svg`,
                                                }"
                                                :size="30"
                                            />
                                        </template>
                                    </template>
                                </div>
                                <div class="callWidgetInfo__box">
                                    <div
                                        v-if="participant.inbox.name"
                                        class="callWidgetInfo__title"
                                    >
                                        {{ participant.inbox.name }}
                                    </div>
                                    <div
                                        v-if="participant.inbox.numberOrCount"
                                        class="callWidgetInfo__number"
                                    >
                                        {{ participant.inbox.numberOrCount }}
                                    </div>
                                    <div
                                        v-if="participant.inbox.description"
                                        class="callWidgetInfo__number"
                                    >
                                        {{ participant.inbox.description }}
                                    </div>
                                </div>
                                <div
                                    v-if="participant.status !== 'calling'"
                                    class="callWidgetInfo__actions"
                                >
                                    <div
                                        class="callWidgetInfo__actions--button"
                                        :class="{
                                            '--disabled': isHoldConferenceCalling,
                                        }"
                                        @click="handleChangeParticipantStatus(participant)"
                                    >
                                        <basic-loader
                                            v-if="participant.status === 'loading'"
                                            :center="true"
                                            aria-label="CallWidget"
                                        />
                                        <template v-else>
                                            <vector-icon
                                                v-if="
                                                    participant.status === 'hold' ||
                                                        isHoldConferenceCalling
                                                "
                                                icon="play-icon"
                                            />
                                            <vector-icon v-else icon="pause-icon" />
                                        </template>
                                    </div>
                                    <div
                                        class="callWidgetInfo__actions--button"
                                        @click="handleParticipantCallEnd(participant)"
                                    >
                                        <basic-loader
                                            v-if="participant.status === 'deletion'"
                                            :center="true"
                                            aria-label="CallWidget"
                                        />
                                        <vector-icon v-else icon="call-end" :size="[18, 9]" />
                                    </div>
                                </div>
                                <div
                                    v-if="participant.status === 'calling'"
                                    class="callWidgetInfo__status"
                                >
                                    Calling...
                                </div>
                            </template>
                            <template v-else>
                                <div class="callWidgetInfo__image">
                                    <avatar :size="30" :contact="participant" />
                                </div>
                                <div class="callWidgetInfo__box">
                                    <div
                                        v-if="participant.number.formattedNumber"
                                        class="callWidgetInfo__title"
                                    >
                                        {{ participant.number.formattedNumber }}
                                    </div>
                                    <div
                                        v-if="participant.number.formattedNumber"
                                        class="callWidgetInfo__number"
                                    >
                                        {{ participant.number.formattedNumber }}
                                    </div>
                                </div>
                                <div
                                    v-if="participant.status !== 'calling'"
                                    class="callWidgetInfo__actions"
                                >
                                    <div
                                        class="callWidgetInfo__actions--button"
                                        :class="{
                                            '--disabled': isHoldConferenceCalling,
                                        }"
                                        @click="handleChangeParticipantStatus(participant)"
                                    >
                                        <basic-loader
                                            v-if="participant.status === 'loading'"
                                            :center="true"
                                            aria-label="CallWidget"
                                        />
                                        <template v-else>
                                            <vector-icon
                                                v-if="
                                                    participant.status === 'hold' ||
                                                        isHoldConferenceCalling
                                                "
                                                icon="play-icon"
                                            />
                                            <vector-icon v-else icon="pause-icon" />
                                        </template>
                                    </div>
                                    <div
                                        class="callWidgetInfo__actions--button"
                                        @click="handleParticipantCallEnd(participant)"
                                    >
                                        <basic-loader
                                            v-if="participant.status === 'deletion'"
                                            :center="true"
                                            aria-label="CallWidget"
                                        />
                                        <vector-icon v-else icon="call-end" :size="[18, 9]" />
                                    </div>
                                </div>
                                <div
                                    v-if="participant.status === 'calling'"
                                    class="callWidgetInfo__status"
                                >
                                    Calling...
                                </div>
                            </template>
                        </div>
                    </div>
                </template>
                <div
                    v-else
                    class="callWidgetInfo"
                    :class="{
                        'callWidgetInfo--onHold': !activeCallWaiting,
                    }"
                >
                    <div class="callWidgetInfo__image">
                        <avatar :size="30" :contact="contactToCallWidget" />
                    </div>
                    <div class="callWidgetInfo__box">
                        <div class="callWidgetInfo__title">
                            {{ contactToCallWidget.name }}
                        </div>
                        <div class="callWidgetInfo__number">
                            {{ contactToCallWidget.formatted_number }}
                        </div>
                    </div>
                </div>
            </template>

            <div
                class="callWidgetVia"
                :class="{
                    'callWidgetVia--onHold': !activeCallWaiting,
                }"
            >
                <div class="callWidgetVia__content">
                    <div class="callWidgetVia__left">
                        <div class="callWidgetVia__image">
                            <svg
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <g clip-path="url(#clip0_282_8439)">
                                    <path
                                        opacity="0.8"
                                        d="M15.0094 10.0084L11.9406 8.69343C11.2719 8.40339 10.4831 8.59627 10.0281 9.16061L9.17062 10.2075C7.77187 9.40218 6.6 8.2303 5.79375 6.8303L6.84219 5.97155C7.40312 5.51468 7.59688 4.7303 7.28438 4.06468L5.99062 0.984363C5.675 0.259363 4.8875 -0.136137 4.12187 0.0411126L1.26906 0.699363C0.521875 0.869675 0 1.52499 0 2.29249C0 9.85217 6.14688 15.9991 13.7063 15.9991C14.4738 15.9991 15.1291 15.4775 15.3 14.7325L15.9581 11.8781C16.1375 11.1084 15.7375 10.3209 15.0094 10.0084ZM14.4969 11.5397L13.8378 14.3962C13.8219 14.4584 13.7719 14.4991 13.7063 14.4991C6.975 14.4991 1.47187 9.02405 1.47187 2.29249C1.47187 2.22705 1.51241 2.1758 1.57638 2.16114L4.45937 1.50249C4.46914 1.50005 4.47939 1.49907 4.48916 1.49907C4.54335 1.49907 4.59413 1.53179 4.61563 1.5806L5.9325 4.65341C5.95625 4.70843 5.94063 4.77405 5.89375 4.81155L4.36938 6.06061C4.1 6.2803 4.01562 6.65843 4.16875 6.97093C5.20031 9.07186 6.92688 10.7991 9.02812 11.8303C9.34056 11.9836 9.71844 11.9016 9.93906 11.6321L11.1897 10.1046C11.2243 10.0606 11.2892 10.044 11.3434 10.0694L14.4141 11.3847C14.475 11.4116 14.5094 11.4772 14.4969 11.5397ZM15.25 -0.000949854H11.75C11.3375 -0.000949854 11 0.334988 11 0.74905C11 1.16311 11.3359 1.49905 11.75 1.49905H13.4394L9.22062 5.7178C8.92766 6.01077 8.92766 6.4853 9.22062 6.77843C9.51359 7.07155 9.98812 7.07139 10.2812 6.77843L14.5 2.55968V4.24905C14.5 4.66468 14.8375 4.99905 15.25 4.99905C15.6625 4.99905 16 4.66468 16 4.24905V0.74905C16 0.334988 15.6656 -0.000949854 15.25 -0.000949854Z"
                                        fill="#4B4B4B"
                                    />
                                </g>
                                <defs>
                                    <clipPath id="clip0_282_8439">
                                        <rect width="16" height="16" fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </div>
                        <div class="callWidgetVia__name">
                            {{ contactFromCallWidget.name }}
                        </div>
                        <div class="callWidgetVia__number">
                            {{ contactFromCallWidget.number.formattedNumber }}
                        </div>
                    </div>
                    <div class="callWidgetVia__right">
                        <span v-if="activeCallWaiting" class="callWidgetVia__time">
                            {{ formattedTime }}
                        </span>
                        <span v-else class="callWidgetVia__status"> On hold </span>
                    </div>
                </div>
            </div>
            <div
                v-if="isCallTransferAvailable || isConferenceCallingAvailable"
                class="callWidgetOptions"
            >
                <div class="callWidgetOptions__box">
                    <template v-if="isConferenceCallingCreated">
                        <div
                            v-tooltip.top="{
                                content: !isHoldConferenceCalling ? 'Put on hold' : 'Resume',
                            }"
                            :class="{
                                callWidgetOptions__item: true,
                                'callWidgetOptions__item--active':
                                    isHoldConferenceCalling || loadingConferenceCallingHoldStatus,
                                'callWidgetOptions__item--disabled':
                                    loadingConferenceCallingHoldStatus,
                            }"
                            @click="handleChangeConferenceCallingHoldStatus"
                        >
                            <basic-loader
                                v-if="loadingConferenceCallingHoldStatus"
                                :center="true"
                                aria-label="CallWidget"
                            />
                            <template v-else>
                                <img
                                    v-if="!isHoldConferenceCalling"
                                    :src="`${$window.Config.cdn_url}/images/app/svg/pause.svg`"
                                    alt="pause"
                                />
                                <img
                                    v-else
                                    :src="`${$window.Config.cdn_url}/images/app/svg/play.svg`"
                                    alt="play"
                                />
                            </template>
                        </div>
                    </template>
                    <template v-else>
                        <div
                            v-tooltip.top="{
                                content: activeCallWaiting ? 'Put on hold' : 'Resume',
                            }"
                            :class="{
                                callWidgetOptions__item: true,
                                'callWidgetOptions__item--active':
                                    !activeCallWaiting || loadingCallWaiting,
                                'callWidgetOptions__item--disabled': isDisabledHoldButton,
                            }"
                            @click="handleChangeCallWaitingStatus"
                        >
                            <basic-loader v-if="loadingCallWaiting" :center="true" aria-label="CallWidget" />
                            <template v-else>
                                <img
                                    v-if="activeCallWaiting"
                                    :src="`${$window.Config.cdn_url}/images/app/svg/pause.svg`"
                                    alt="pause"
                                />
                                <img
                                    v-else
                                    :src="`${$window.Config.cdn_url}/images/app/svg/play.svg`"
                                    alt="play"
                                />
                            </template>
                        </div>
                    </template>
                    <div
                        v-if="isShowCallTransferButton"
                        v-tooltip.top="{
                            content: activeCallTransfer ? 'Cancel' : 'Transfer',
                        }"
                        :class="{
                            callWidgetOptions__item: true,
                            'callWidgetOptions__item--active':
                                activeCallTransfer || loadingCallTransfer,
                            'callWidgetOptions__item--disabled': isDisabledCallTransferButton,
                        }"
                        @click="handleChangeCallTransferStatus"
                    >
                        <basic-loader v-if="loadingCallTransfer" :center="true" aria-label="CallWidget" />
                        <template v-else>
                            <img
                                v-if="activeCallTransfer"
                                :src="`${$window.Config.cdn_url}/images/app/svg/transfer-active.svg`"
                                alt="transfer active"
                            />
                            <img
                                v-else
                                :src="`${$window.Config.cdn_url}/images/app/svg/transfer.svg`"
                                alt="transfer"
                            />
                        </template>
                    </div>
                    <div
                        v-if="isConferenceCallingAvailable"
                        v-tooltip.top="{
                            content: tooltipAddConferenceCall,
                        }"
                        :class="{
                            callWidgetOptions__item: true,
                            'callWidgetOptions__item--active':
                                activeConferenceCalling || loadingConferenceCalling,
                            'callWidgetOptions__item--disabled': isDisabledConferenceCallingButton,
                        }"
                        @click="handleChangeConferenceCallingStatus"
                    >
                        <basic-loader v-if="loadingConferenceCalling" :center="true" aria-label="CallWidget" />
                        <template v-else>
                            <span class="plus" />
                        </template>
                    </div>
                </div>
            </div>

            <div
                class="callWidgetMenu"
                :class="{
                    'callWidgetMenu--options': isCallTransferAvailable,
                }"
            >
                <div v-if="hasAcceptVoice" class="callWidgetMenu__box">
                    <div
                        :class="{
                            callWidgetMenu__item: true,
                            'callWidgetMenu__item--active': activeMute,
                            'callWidgetMenu__item--disabled': isDisabledMuteButton,
                        }"
                        @click="handleMute"
                    >
                        <img
                            class="callWidgetMenu__noActive"
                            :src="`${$window.Config.cdn_url}/images/app/svg/mute-icon.svg`"
                            alt=""
                        />
                        <img
                            class="callWidgetMenu__active"
                            :src="`${$window.Config.cdn_url}/images/app/svg/mute-icon-active.svg`"
                            alt=""
                        />
                    </div>
                    <div
                        :class="{
                            callWidgetMenu__item: true,
                            'callWidgetMenu__item--active': activeRecord,
                            'callWidgetMenu__item--disabled':
                                !hasConnectOpen || loadingCallTransfer || loadingCallWaiting,
                        }"
                        @click="handleRecord"
                    >
                        <img
                            class="callWidgetMenu__noActive"
                            :src="`${$window.Config.cdn_url}/images/app/svg/stream-icon.svg`"
                            alt=""
                        />
                        <img
                            class="callWidgetMenu__active"
                            :src="`${$window.Config.cdn_url}/images/app/svg/stream-icon-active.svg`"
                            alt=""
                        />
                    </div>
                    <div
                        :class="{
                            callWidgetMenu__item: true,
                            'callWidgetMenu__item--active': activeKeypad,
                            'callWidgetMenu__item--disabled':
                                activeCallTransfer || loadingCallTransfer || !hasConnectOpen,
                        }"
                        @click="handleKeypad"
                    >
                        <img
                            class="callWidgetMenu__noActive"
                            :src="`${$window.Config.cdn_url}/images/app/svg/keypad.svg`"
                            alt=""
                        />
                        <img
                            class="callWidgetMenu__active"
                            :src="`${$window.Config.cdn_url}/images/app/svg/keypad-active.svg`"
                            alt=""
                        />
                    </div>
                    <div
                        v-if="!isCallTransferAvailable"
                        v-tooltip.top="{
                            content: activeCallWaiting ? 'Put on hold' : 'Resume',
                        }"
                        :class="{
                            callWidgetMenu__item: true,
                            'callWidgetMenu__item--active':
                                !activeCallWaiting || loadingCallWaiting,
                            'callWidgetMenu__item--disabled': isDisabledHoldButton,
                        }"
                        @click="handleChangeCallWaitingStatus"
                    >
                        <basic-loader v-if="loadingCallWaiting" :center="true" aria-label="CallWidget" />
                        <template v-else>
                            <img
                                v-if="activeCallWaiting"
                                :src="`${$window.Config.cdn_url}/images/app/svg/pause.svg`"
                                alt="pause"
                            />
                            <img
                                v-else
                                :src="`${$window.Config.cdn_url}/images/app/svg/play.svg`"
                                alt="play"
                            />
                        </template>
                    </div>
                </div>
                <div
                    v-if="hasIncoming && !hasAcceptVoice"
                    class="callWidgetMenu__box callWidgetMenu__box--declined-options"
                >
                    <div
                        v-tooltip.top="{
                            content: 'Mute',
                        }"
                        :class="{
                            callWidgetMenu__item: true,
                            'callWidgetMenu__item--active': activeIncomingMute,
                        }"
                        @click="handleIncomingMute"
                    >
                        <svg
                            class="callWidgetMenu__noActive"
                            width="18"
                            height="14"
                            viewBox="0 0 18 14"
                            fill="#4A4A4A"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M17.7459 12.8494L15.2483 10.9432C16.4265 9.93766 17.1045 8.51604 17.1045 7.01224C17.1045 5.44764 16.3775 3.96904 15.1105 2.98294C14.823 2.75439 14.3976 2.79378 14.1602 3.07454C13.9237 3.3553 13.9659 3.76974 14.2542 3.99983C15.2084 4.736 15.7541 5.84262 15.7541 7.01224C15.7541 8.18159 15.2072 9.28821 14.2544 10.05C14.225 10.0735 14.2094 10.1055 14.1852 10.1325L12.9381 9.18091C12.9523 9.18177 12.9654 9.18981 12.9797 9.18981C13.13 9.18981 13.2821 9.14103 13.407 9.04174C14.0409 8.53521 14.4038 7.79838 14.4038 7.01224C14.4038 6.22747 14.0406 5.48872 13.4068 4.98362C13.1176 4.75507 12.6919 4.79531 12.4573 5.07692C12.2208 5.35768 12.263 5.77212 12.5523 6.00221C12.8706 6.25624 13.0534 6.62328 13.0534 7.01224C13.0534 7.4012 12.8706 7.7688 12.5524 8.02244C12.3353 8.19531 12.2576 8.47194 12.3323 8.71792L10.8029 7.55186V1.75306C10.8029 1.4082 10.5965 1.09539 10.2729 0.954322C9.94934 0.812215 9.56928 0.86897 9.30427 1.09837L6.04572 3.91973L1.09193 0.139998C0.968153 0.0458261 0.821303 0 0.676141 0C0.47584 0 0.276917 0.0865026 0.144162 0.251701C-0.0861842 0.537669 -0.03504 0.951008 0.258603 1.1748L16.8875 13.8598C17.1829 14.0845 17.6069 14.0332 17.8353 13.7481C18.0919 13.4876 18.0385 13.074 17.7459 12.8494ZM1.80058 5.69745V8.32704C1.80058 9.05319 2.40514 9.61718 3.15093 9.61718H5.50953L9.30455 12.9014C9.47222 13.0713 9.68602 13.148 9.90264 13.148C10.0275 13.148 10.1547 13.1224 10.2729 13.0702C10.5975 12.9288 10.8029 12.6166 10.8029 12.2714V10.8925L2.49685 4.55522C2.08331 4.77983 1.80058 5.17975 1.80058 5.69745Z"
                            />
                        </svg>
                        <svg
                            class="callWidgetMenu__active"
                            width="18"
                            height="14"
                            viewBox="0 0 18 14"
                            fill="#2389FD"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M17.7459 12.8494L15.2483 10.9432C16.4265 9.93766 17.1045 8.51604 17.1045 7.01224C17.1045 5.44764 16.3775 3.96904 15.1105 2.98294C14.823 2.75439 14.3976 2.79378 14.1602 3.07454C13.9237 3.3553 13.9659 3.76974 14.2542 3.99983C15.2084 4.736 15.7541 5.84262 15.7541 7.01224C15.7541 8.18159 15.2072 9.28821 14.2544 10.05C14.225 10.0735 14.2094 10.1055 14.1852 10.1325L12.9381 9.18091C12.9523 9.18177 12.9654 9.18981 12.9797 9.18981C13.13 9.18981 13.2821 9.14103 13.407 9.04174C14.0409 8.53521 14.4038 7.79838 14.4038 7.01224C14.4038 6.22747 14.0406 5.48872 13.4068 4.98362C13.1176 4.75507 12.6919 4.79531 12.4573 5.07692C12.2208 5.35768 12.263 5.77212 12.5523 6.00221C12.8706 6.25624 13.0534 6.62328 13.0534 7.01224C13.0534 7.4012 12.8706 7.7688 12.5524 8.02244C12.3353 8.19531 12.2576 8.47194 12.3323 8.71792L10.8029 7.55186V1.75306C10.8029 1.4082 10.5965 1.09539 10.2729 0.954322C9.94934 0.812215 9.56928 0.86897 9.30427 1.09837L6.04572 3.91973L1.09193 0.139998C0.968153 0.0458261 0.821303 0 0.676141 0C0.47584 0 0.276917 0.0865026 0.144162 0.251701C-0.0861842 0.537669 -0.03504 0.951008 0.258603 1.1748L16.8875 13.8598C17.1829 14.0845 17.6069 14.0332 17.8353 13.7481C18.0919 13.4876 18.0385 13.074 17.7459 12.8494ZM1.80058 5.69745V8.32704C1.80058 9.05319 2.40514 9.61718 3.15093 9.61718H5.50953L9.30455 12.9014C9.47222 13.0713 9.68602 13.148 9.90264 13.148C10.0275 13.148 10.1547 13.1224 10.2729 13.0702C10.5975 12.9288 10.8029 12.6166 10.8029 12.2714V10.8925L2.49685 4.55522C2.08331 4.77983 1.80058 5.17975 1.80058 5.69745Z"
                            />
                        </svg>
                    </div>
                    <div
                        v-tooltip.top="{
                            content: 'SMS',
                        }"
                        :class="{
                            callWidgetMenu__item: true,
                            'callWidgetMenu__item--active': activeReplay,
                        }"
                        @click="handleReplay"
                    >
                        <svg
                            class="callWidgetMenu__noActive"
                            width="16"
                            height="14"
                            viewBox="0 0 16 14"
                            fill="#4A4A4A"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M11.0634 0H1.80938C0.811563 0 0 0.810199 0 1.80633V9.90208C0 10.2855 0.434344 10.5016 0.740938 10.283L3.31813 8.44734C3.53438 8.29354 3.78875 8.21212 4.05438 8.21212H9.72281C10.7206 8.21212 11.5322 7.40192 11.5322 6.40578V0.467962C11.5322 0.209647 11.3222 0 11.0634 0ZM8.78656 5.6689H3.37063C3.11188 5.6689 2.90188 5.45956 2.90188 5.20093C2.90188 4.94262 3.11188 4.73297 3.37063 4.73297H8.78656C9.04531 4.73297 9.25531 4.94262 9.25531 5.20093C9.25531 5.45956 9.04531 5.6689 8.78656 5.6689ZM8.78656 3.48507H3.37063C3.11188 3.48507 2.90188 3.27574 2.90188 3.01711C2.90188 2.75879 3.11188 2.54915 3.37063 2.54915H8.78656C9.04531 2.54915 9.25531 2.75879 9.25531 3.01711C9.25531 3.27574 9.04531 3.48507 8.78656 3.48507Z"
                            />
                            <path
                                d="M16 5.43653V13.532C16 13.9128 15.5678 14.1331 15.259 13.9129L12.6818 12.0775C12.4656 11.9237 12.2112 11.8423 11.9456 11.8423H6.27715C5.27934 11.8423 4.46777 11.0318 4.46777 10.0357V9.44841C4.46777 9.28272 4.60209 9.14841 4.76777 9.14841H9.72277C11.2375 9.14841 12.4696 7.91829 12.4696 6.40615V3.92988C12.4696 3.7642 12.604 3.62988 12.7696 3.62988H14.1906C15.1884 3.62988 16 4.44039 16 5.43653Z"
                            />
                        </svg>
                        <svg
                            class="callWidgetMenu__active"
                            width="16"
                            height="14"
                            viewBox="0 0 16 14"
                            fill="#2389FD"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M11.0634 0H1.80938C0.811563 0 0 0.810199 0 1.80633V9.90208C0 10.2855 0.434344 10.5016 0.740938 10.283L3.31813 8.44734C3.53438 8.29354 3.78875 8.21212 4.05438 8.21212H9.72281C10.7206 8.21212 11.5322 7.40192 11.5322 6.40578V0.467962C11.5322 0.209647 11.3222 0 11.0634 0ZM8.78656 5.6689H3.37063C3.11188 5.6689 2.90188 5.45956 2.90188 5.20093C2.90188 4.94262 3.11188 4.73297 3.37063 4.73297H8.78656C9.04531 4.73297 9.25531 4.94262 9.25531 5.20093C9.25531 5.45956 9.04531 5.6689 8.78656 5.6689ZM8.78656 3.48507H3.37063C3.11188 3.48507 2.90188 3.27574 2.90188 3.01711C2.90188 2.75879 3.11188 2.54915 3.37063 2.54915H8.78656C9.04531 2.54915 9.25531 2.75879 9.25531 3.01711C9.25531 3.27574 9.04531 3.48507 8.78656 3.48507Z"
                            />
                            <path
                                d="M16 5.43653V13.532C16 13.9128 15.5678 14.1331 15.259 13.9129L12.6818 12.0775C12.4656 11.9237 12.2112 11.8423 11.9456 11.8423H6.27715C5.27934 11.8423 4.46777 11.0318 4.46777 10.0357V9.44841C4.46777 9.28272 4.60209 9.14841 4.76777 9.14841H9.72277C11.2375 9.14841 12.4696 7.91829 12.4696 6.40615V3.92988C12.4696 3.7642 12.604 3.62988 12.7696 3.62988H14.1906C15.1884 3.62988 16 4.44039 16 5.43653Z"
                            />
                        </svg>
                    </div>
                </div>

                <div
                    :class="{
                        callWidgetMenu__box: true,
                        'callWidgetMenu__box--accept': !hasAcceptVoice,
                    }"
                >
                    <div
                        class="callWidgetMenu__button isDropdown"
                        :class="{
                            'callWidgetMenu__button--disabled': loadingCallEnd,
                            isDropdown: isConferenceCallingCreated,
                        }"
                        @click="
                            isConferenceCallingCreated ? handleShowCancelButtons() : handleCancel()
                        "
                    >
                        <img
                            :src="`${$window.Config.cdn_url}/images/app/svg/phone-close.svg`"
                            alt=""
                        />
                        <div v-if="isShowCancelButtons" class="dropdownContainer">
                            <div class="dropdownButton" @click="handleCancel('end-all')">
                                End the call for all
                            </div>
                            <div class="dropdownButton" @click="handleCancel('leave')">
                                Leave the call
                            </div>
                        </div>
                    </div>

                    <div
                        v-if="!hasAcceptVoice"
                        class="callWidgetMenu__button"
                        @click="handleAccept"
                    >
                        <fa-icon :icon="['fas', 'phone-alt']" />
                    </div>
                </div>
            </div>
            <div v-if="isShowCallWidgetSearch" class="callWidgetSearch">
                <div class="callWidgetSearch__title">
                    {{ callWidgetSearchTitle }}
                </div>
                <div class="callWidgetSearch__input">
                    <form-input
                        v-model="form.search"
                        :placeholder="
                            activeCallTransfer
                                ? 'Search inboxes or dial a number...'
                                : 'Search inboxes or contacts or dial a number...'
                        "
                        :error="
                            form.search && !isValidNumber(form.search) && isShowSearchForFeature
                                ? 'Please use a valid number'
                                : null
                        "
                    />
                    <div class="callWidgetSearch__input__loading">
                        <fa-icon v-if="loadingSearch" icon="circle-notch" spin />
                    </div>
                </div>
                <div v-if="isShowSearchForFeature" class="callWidgetSearch__button">
                    <button
                        class="button is-primary"
                        :disabled="!isValidNumber(form.search) && isShowSearchForFeature"
                        @click="handleCallWidgetSearchToNumber"
                    >
                        {{ callWidgetSearchButton }}
                    </button>
                </div>
                <template v-else>
                    <div class="callWidgetSearch__inboxes">
                        <template v-if="hasInboxes">
                            <span class="callWidgetSearch__label">Inboxes</span>
                            <div
                                v-for="inbox in limitedInboxList"
                                :key="inbox.id"
                                class="inbox"
                                @click="handleSelectInboxOrContact(inbox, 'inbox')"
                            >
                                <avatar
                                    v-if="inbox.isAircallNumber"
                                    :contact="{
                                        photo_url: `${$window.Config.cdn_url}/images/app/integrations/aircall.png`,
                                    }"
                                    :size="24"
                                />
                                <template v-else>
                                    <avatar
                                        v-if="inbox.hasOwnProperty('teams')"
                                        :contact="{
                                            photo_url: `${$window.Config.cdn_url}/images/app/svg/inbox_group.svg`,
                                        }"
                                        :size="24"
                                    />
                                    <avatar
                                        v-else-if="inbox.id"
                                        :useVectorIcon="inbox.is_smart"
                                        :contact="{
                                            first_name: inbox.name,
                                            color: inbox.color,
                                            fill: inbox.is_smart ? 'white' : inbox.color,
                                            icon: inbox.is_smart ? 'smart-inbox' : null,
                                        }"
                                        :sizeIcon="24 / 2"
                                        :size="24"
                                    />
                                    <avatar
                                        v-else-if="inbox.id === null"
                                        :contact="{
                                            photo_url: `${$window.Config.cdn_url}/images/app/svg/all_inboxes.svg`,
                                        }"
                                        :size="24"
                                    />
                                </template>
                                <div class="inbox-info">
                                    <template v-if="inbox.id">
                                        <span class="inbox-label">{{ inbox.name }}</span>
                                        <span class="inbox-caption">
                                            <template v-if="inbox.numberOrCount">
                                                {{ inbox.numberOrCount }}
                                            </template>

                                            <template v-if="inbox.description">
                                                {{ inbox.description }}
                                            </template>
                                        </span>
                                    </template>
                                </div>
                            </div>
                            <div
                                v-if="isShowButtonMoreInboxes && !isClickedButtonMoreInboxes"
                                class="callWidgetSearch__showMore"
                                @click="handleShowAllInboxes"
                            >
                                +{{ numberHiddenInboxes }} more
                            </div>
                        </template>
                        <template v-if="!activeCallTransfer">
                            <template v-if="hasContacts">
                                <span class="callWidgetSearch__label">Contacts</span>
                                <div
                                    v-for="contact in limitedContactList"
                                    :key="contact.id"
                                    class="inbox"
                                    @click="handleSelectInboxOrContact(contact, 'contact')"
                                >
                                    <avatar
                                        v-if="contact.id"
                                        :contact="{
                                            first_name: contact.name,
                                            color: contact.color,
                                            fill: contact.color,
                                        }"
                                        :sizeIcon="24 / 2"
                                        :size="24"
                                    />
                                    <avatar
                                        v-else-if="contact.id === null"
                                        :contact="{
                                            photo_url: `${$window.Config.cdn_url}/images/app/svg/all_inboxes.svg`,
                                        }"
                                        :size="24"
                                    />
                                    <div class="inbox-info">
                                        <template v-if="contact.id">
                                            <span class="inbox-label">{{
                                                contact.full_name || contact.formatted_number
                                            }}</span>
                                            <span class="inbox-caption">
                                                <template v-if="contact.formatted_number">
                                                    {{ contact.formatted_number }}
                                                </template>
                                            </span>
                                        </template>
                                    </div>
                                </div>
                                <div
                                    v-if="isShowButtonMoreContacts && !isClickedButtonMoreContacts"
                                    class="callWidgetSearch__showMore"
                                    @click="handleShowAllContacts"
                                >
                                    +{{ numberHiddenContacts }} more
                                </div>
                            </template>
                        </template>
                    </div>
                </template>
            </div>
        </template>
        <div v-if="activeReplay" class="callWidgetMenu__replay-block">
            <p class="control">
                <textarea
                    ref="message"
                    v-model="replayMessage"
                    class="textarea message-form-textarea"
                    placeholder="Enter message"
                />
            </p>
            <button
                :disabled="sendDisabled"
                class="button is-primary callWidgetMenu__replay-button"
                @click="handleSendReplay"
            >
                Send message
            </button>
        </div>
    </div>
</template>

<script>
import { mapState } from 'pinia';
import stores from 'store/modules';
import VoiceOrVideoMixin from '../../mixins/voice-or-video';
import SearchContactMixin from '../../mixins/search-contact';
import CallKeyPad from './CallKeyPad';
import Form from 'core/Form';
import { parsePhoneNumber } from 'libphonenumber-js';
import { debounce } from 'lodash';
import { CancelToken } from 'core/api';

export default {
    components: {
        CallKeyPad,
    },

    mixins: [VoiceOrVideoMixin, SearchContactMixin],

    data: () => ({
        showRollup: false,
        activeMute: false,
        activeRecord: false,
        activeKeypad: false,
        activeReplay: false,
        replayMessage: '',
        messageSent: false,
        activeCallWaiting: true,
        activeCallTransfer: false,
        activeConferenceCalling: false,
        form: new Form({
            inboxId: null,
            search: '',
            smartInboxNumber: 0,
        }),
        holdCount: 0,
        busy: false,
        active: false,
        searchResult: null,
        conferenceCallingParticipants: [],
        isClickedButtonMoreInboxes: false,
        isClickedButtonMoreContacts: false,
        isCancelClicked: false,
        isShowCancelButtons: false,
        fullInboxesList: [],
    }),

    computed: {
        classesRollup() {
            return {
                callWidgetTop__rollup: true,
                'callWidgetTop__rollup--active': this.showRollup,
            };
        },

        sendDisabled() {
            return !this.replayMessage.trim().length || this.messageSent;
        },

        inboxList() {
            let inboxes = [];

            inboxes = this.fullInboxesList
                .filter((inbox) => {
                    if (this.activeCallTransfer) {
                        return !inbox.isGroupInbox;
                    }

                    return !(
                        (inbox.id === this.inbox.id && !this.inbox.isGroupInbox) ||
                        inbox.id === this.contactFromCallWidget.id ||
                        inbox.number?.number === this.contactToCallWidget.number ||
                        Number(inbox.number?.national_number) ===
                            Number(this.contactToCallWidget.national_number)
                    );
                })
                .sort((a, b) => {
                    if (a.name.toLowerCase() < b.name.toLowerCase()) {
                        return -1;
                    }
                    if (a.name.toLowerCase() > b.name.toLowerCase()) {
                        return 1;
                    }
                    return 0;
                })
                .sort((a, b) => {
                    if (a.is_favorite && !b.is_favorite) {
                        return -1;
                    }
                    if (!a.is_favorite && b.is_favorite) {
                        return 1;
                    }
                    return 0;
                });

            if (this.conferenceCallingParticipants.length) {
                inboxes = inboxes.filter((item) => {
                    const inboxesSelected = this.conferenceCallingParticipants.filter(
                        (participant) => {
                            if (
                                participant.hasOwnProperty('inbox') &&
                                item?.id === participant?.inbox?.id
                            ) {
                                return participant;
                            }
                        }
                    );

                    if (!(inboxesSelected && inboxesSelected[0]?.inbox.id === item.id)) {
                        return item;
                    }
                });
            }

            return inboxes.filter((item) => {
                const query = this.form.search.toLowerCase().replaceAll(/\s/g, '');

                return this.searchByNameOrNumber(item, query);
            });
        },

        limitedInboxList() {
            return this.isClickedButtonMoreInboxes ? this.inboxList : this.inboxList.slice(0, 3);
        },

        isCallTransferAvailable() {
            if (this.hasIncoming) {
                return this.hasAcceptVoice;
            }

            return true;
        },

        isConferenceCallingAvailable() {
            if (this.hasIncoming) {
                return (
                    this.hasAcceptVoice &&
                    this.contactToCallWidget.currentInbox.number?.conference_calling
                );
            }

            return this.contactFromCallWidget.number.conference_calling;
        },

        isDisabledHoldButton() {
            return Boolean(
                this.activeCallTransfer ||
                    this.loadingCallTransfer ||
                    this.loadingCallWaiting ||
                    !this.hasConnectOpen
            );
        },

        isDisabledCallTransferButton() {
            return Boolean(
                !this.isCallTransferAvailable ||
                    this.loadingCallTransfer ||
                    this.loadingCallWaiting ||
                    !this.hasConnectOpen
            );
        },

        isDisabledMuteButton() {
            return Boolean(this.activeCallTransfer || this.loadingCallTransfer);
        },

        isDisabledConferenceCallingButton() {
            return Boolean(
                this.loadingConferenceCalling ||
                    !this.hasConnectOpen ||
                    !this.activeCallWaiting ||
                    this.loadingCallWaiting ||
                    this.isConferenceCallCapacityReached
            );
        },

        isShowCallWidgetSearch() {
            return (
                (this.isCallTransferAvailable && this.activeCallTransfer) ||
                (this.isConferenceCallingAvailable && this.activeConferenceCalling)
            );
        },

        isShowSearchForFeature() {
            if (this.activeCallTransfer) {
                return !this.hasInboxes;
            }

            return !this.hasInboxes && !this.hasContacts;
        },

        callWidgetSearchTitle() {
            return this.activeCallTransfer ? 'Transfer Call To' : 'Add People To Call';
        },

        callWidgetSearchButton() {
            return this.activeCallTransfer ? 'Transfer Call' : 'Add to Call';
        },

        hasInboxes() {
            return this.inboxList?.length;
        },

        hasContacts() {
            return this.searchResult?.length;
        },

        isConferenceCallCapacityReached() {
            return this.conferenceCallingParticipants.length > 250;
        },

        isConferenceCallingCreated() {
            return Boolean(this.conferenceName && this.conferenceSid);
        },

        isShowCallTransferButton() {
            return !(
                this.activeConferenceCalling ||
                this.isConferenceCallingCreated ||
                this.loadingConferenceCalling
            );
        },

        tooltipAddConferenceCall() {
            if (this.isConferenceCallCapacityReached) {
                return 'Conference call capacity reached';
            }

            return this.activeConferenceCalling ? 'Cancel' : 'Add people to call';
        },

        isShowButtonMoreInboxes() {
            return this.inboxList.length > 3;
        },

        numberHiddenInboxes() {
            return this.inboxList.length - 3;
        },

        isShowButtonMoreContacts() {
            return this.searchResult.length > 3;
        },

        numberHiddenContacts() {
            return this.searchResult.length - 3;
        },

        limitedContactList() {
            return this.isClickedButtonMoreContacts
                ? this.searchResult
                : this.searchResult.slice(0, 3);
        },

        ...mapState(stores.User, ['user']),
        ...mapState(stores.Inboxes, [
            'inbox',
            'inboxes',
            'inboxesArray',
            'inboxesSettingsArray',
            'inboxesGroups',
            'inboxesGroupsArray',
        ]),
        ...mapState(stores.Conversations, ['conversations']),
        ...mapState(stores.VoiceOrVideo, [
            'showCallWidget',
            'contactFromCallWidget',
            'contactToCallWidget',
            'twilioRecord',
            'isRecordAutomatically',
            'loadingCallTransfer',
            'loadingCallWaiting',
            'loadingConferenceCalling',
            'contactsSearchLoading',
            'conferenceName',
            'conferenceSid',
            'conferenceParticipantUpdate',
            'loadingConferenceCallingHoldStatus',
            'isHoldConferenceCalling',
            'loadingCallEnd',
            'activeIncomingMute',
        ]),
    },

    watch: {
        hasConnectOpen(status) {
            if (status) {
                this.handleInitRecord('init');
            }
        },

        'form.search'() {
            this.searchResult = null;
            this.active = false;
            this.resetSourceAxios();
            this.busy = false;

            if (!this.busy && !this.activeCallTransfer) {
                this.debounceSearch();
            }
        },

        conferenceParticipantUpdate(data) {
            if (data && data.conferenceSid === this.conferenceSid) {
                if (data.event_type === 'participant-leave') {
                    this.conferenceCallingParticipants = this.conferenceCallingParticipants.filter(
                        (item) => item.label !== data.participant_label
                    );

                    if (!this.conferenceCallingParticipants.length) {
                        this.handleCancel();
                    }

                    return;
                }

                this.conferenceCallingParticipants = this.conferenceCallingParticipants.map(
                    (participant) => {
                        if (participant.label === data.participant_label) {
                            const currentLabelData = this.parseLabel(participant.label);
                            if (currentLabelData.key === 'inbox_id') {
                                return {
                                    inbox: participant.inbox,
                                    status: data.event_type,
                                    label: participant.label,
                                };
                            }

                            if (currentLabelData.key === 'contact_id') {
                                return {
                                    contact: participant.contact,
                                    status: data.event_type,
                                    label: participant.label,
                                };
                            }

                            if (currentLabelData.key === 'number') {
                                return {
                                    number: participant.number,
                                    status: data.event_type,
                                    label: participant.label,
                                };
                            }
                        }

                        return participant;
                    }
                );
            }
        },

        isShowCallWidgetSearch() {
            this.form.search = '';
            this.isClickedButtonMoreInboxes = false;
            this.isClickedButtonMoreContacts = false;
        },
    },

    methods: {
        init() {
            this.debounceSearch = debounce(this.search, 500);
            this.getFullInboxesListForOrganisation();
        },

        async getFullInboxesListForOrganisation() {
            this.fullInboxesList = await this.$store.dispatch('getTeamsAll');
        },

        async search() {
            this.busy = true;
            this.active = true;

            this.resetSourceAxios();

            this.source = CancelToken.source();

            try {
                if (this.form.search) {
                    const contacts = await this.$store.dispatch('searchContacts', {
                        query: this.form.search,
                        update: false,
                        cancelToken: this.source,
                    });

                    if (contacts) {
                        this.searchResult = contacts
                            ?.filter((contact) => {
                                return !(
                                    (contact.id === this.inbox.id && !this.inbox.isGroupInbox) ||
                                    contact.id === this.contactFromCallWidget.id ||
                                    contact.number === this.contactToCallWidget.number ||
                                    Number(contact.national_number) ===
                                        Number(this.contactToCallWidget.national_number)
                                );
                            })
                            .sort((a, b) => {
                                if (a.full_name.toLowerCase() < b.full_name.toLowerCase()) {
                                    return -1;
                                }
                                if (a.full_name.toLowerCase() > b.full_name.toLowerCase()) {
                                    return 1;
                                }
                                return 0;
                            });

                        if (this.conferenceCallingParticipants.length) {
                            this.searchResult = this.searchResult.filter((item) => {
                                const contactSelected = this.conferenceCallingParticipants.filter(
                                    (participant) => {
                                        if (
                                            participant.hasOwnProperty('contact') &&
                                            item?.id === participant?.contact?.id
                                        ) {
                                            return participant;
                                        }
                                    }
                                );

                                if (
                                    !(contactSelected && contactSelected[0]?.contact.id === item.id)
                                ) {
                                    return item;
                                }
                            });
                        }
                    }
                }
            } catch (err) {
                this.$log.error(e, this.$options.__file, 'search');
            } finally {
                this.busy = false;
                this.source = null;
            }
        },

        searchByNameOrNumber(item, query) {
            if (item.name.toLowerCase().replaceAll(/\s/g, '').includes(query)) return true;

            if (item.is_smart) {
                let numberMatch = false;
                if (item.numbers) {
                    item.numbers.forEach((el) => {
                        if (this.numberIncluded(el, query)) {
                            numberMatch = true;
                        }
                    });
                }

                if (numberMatch) {
                    return true;
                }
            }

            if (item.type === 'inbox_group') {
                let numberMatch = false;
                const phones = this.getPhones(item.teams);
                phones.forEach((el) => {
                    if (this.numberIncluded(el, query)) {
                        numberMatch = true;
                    }
                });

                if (numberMatch) {
                    return true;
                }
            }

            return this.numberIncluded(item.number, query);
        },

        numberIncluded(number, query) {
            if (number) {
                if (
                    number.national_number &&
                    number.national_number.replaceAll(/\s/g, '').includes(query)
                ) {
                    return true;
                }

                if (
                    number.formatted_number &&
                    number.formatted_number.replaceAll(/\s/g, '').includes(query)
                ) {
                    return true;
                }

                if (number.number && number.number.replaceAll(/\s/g, '').includes(query)) {
                    return true;
                }
            }

            return false;
        },

        handleIncomingMute() {
            this.$store.dispatch('updateStateVoiceTwilio', [
                'activeIncomingMute',
                !this.activeIncomingMute,
            ]);
            window.device.muteIncomingNotification(!this.activeIncomingMute);
        },

        async handleSendReplay() {
            this.messageSent = true;

            const messageForm = new Form({
                message: this.replayMessage,
                send_at: '',
                media_url: [],
                images_url: [],
                video_url: [],
                audio_url: [],
                docs_url: [],
                type: null,
                stop_on_response: false,
                manual_created: true,
                call_sid: window.connect.parameters.CallSid,
                should_save_draft: true,
            });

            const params = {
                contactId: this.contactToCallWidget.id,
                teamId: this.contactFromCallWidget.id,
            };

            const conversation = await this.$store.dispatch('createConversation', params);

            await this.$store.dispatch('createMessagesById', {
                form: messageForm,
                id: conversation.id,
            });

            this.disconnectTwilio();
        },

        handleReplay() {
            this.activeReplay = !this.activeReplay;
        },

        handleRollup(e) {
            e.stopPropagation();

            this.showRollup = !this.showRollup;
        },

        handleMute() {
            if (this.isDisabledMuteButton) return;

            this.activeMute = !this.activeMute;

            window.connect.mute(this.activeMute);
        },

        async handleRecord() {
            if (!this.hasConnectOpen || this.loadingCallTransfer || this.loadingCallWaiting) return;

            this.activeRecord = !this.activeRecord;

            this.handleInitRecord('toggle', this.activeRecord);
        },

        handleKeypad() {
            if (this.activeCallTransfer || this.loadingCallTransfer) return;
            this.activeKeypad = !this.activeKeypad;
        },

        async handleCancel(actionType = '') {
            if (['end-all', 'leave'].includes(actionType)) {
                this.isShowCancelButtons = false;
            }

            if (this.loadingCallEnd || this.isCancelClicked) return;
            this.isCancelClicked = true;

            if (this.isConferenceCallingCreated) {
                if (actionType === 'end-all') {
                    const callEndAllResponse = await this.$store.dispatch(
                        'conferenceCallingEndAll',
                        {
                            conferenceSid: this.conferenceSid,
                        }
                    );
                    await this.$store.dispatch('resetConferenceCallingStatus');

                    if (typeof callEndAllResponse === 'boolean' && callEndAllResponse) {
                        return;
                    } else {
                        this.isCancelClicked = false;
                    }
                } else {
                    await this.$store.dispatch('resetConferenceCallingStatus');
                }
            } else {
                const callEndResponse = await this.$store.dispatch('callEnd');
                if (typeof callEndResponse === 'boolean' && callEndResponse) {
                    return;
                } else {
                    this.isCancelClicked = false;
                }
            }

            this.disconnectTwilio();
        },

        handleAccept() {
            this.acceptTwilio();
        },

        handleChangeKeyPad(data) {
            console.log(data);
        },

        async handleChangeCallWaitingStatus() {
            if (this.isDisabledHoldButton) return;

            if (this.activeCallWaiting) {
                const holdStatusResponse = await this.$store.dispatch('updateVoiceHoldStatus', {
                    isFirstHold: this.holdCount === 0,
                });

                if (holdStatusResponse) {
                    this.holdCount += 1;
                }

                this.activeCallWaiting = !holdStatusResponse;
                if (!this.activeMute && holdStatusResponse) this.handleMute();
            } else {
                const unholdStatusResponse = await this.$store.dispatch('updateVoiceUnholdStatus', {
                    callSid: window.connect.parameters.CallSid,
                });

                this.activeCallWaiting = unholdStatusResponse;
                if (this.activeMute && unholdStatusResponse) this.handleMute();
            }
        },

        async handleChangeConferenceCallingHoldStatus() {
            if (this.loadingConferenceCallingHoldStatus) return;

            if (this.isHoldConferenceCalling) {
                const resumeResponse = await this.$store.dispatch('setConferenceCallingResume', {
                    conferenceSid: this.conferenceSid,
                });
                if (this.activeMute && resumeResponse) this.handleMute();
                return;
            }

            const holdResponse = await this.$store.dispatch('setConferenceCallingHold', {
                conferenceSid: this.conferenceSid,
            });
            if (!this.activeMute && holdResponse) this.handleMute();
        },

        async handleChangeCallTransferStatus() {
            if (this.isDisabledCallTransferButton) return;

            if (!this.activeCallTransfer) {
                if (!this.activeMute) this.handleMute();
                if (this.activeCallWaiting) {
                    const holdStatusResponse = await this.$store.dispatch('updateVoiceHoldStatus', {
                        isFirstHold: this.holdCount === 0,
                        isSendSegmentEvent: false,
                    });

                    if (holdStatusResponse) {
                        this.holdCount += 1;
                    }

                    this.activeCallWaiting = !holdStatusResponse;
                }
                this.activeCallTransfer = true;
            } else {
                if (this.activeMute) this.handleMute();
                if (!this.activeCallWaiting) {
                    this.activeCallWaiting = await this.$store.dispatch('updateVoiceUnholdStatus', {
                        callSid: window.connect.parameters.CallSid,
                        isSendSegmentEvent: false,
                    });
                }
                this.activeCallTransfer = false;
            }
        },

        async handleCallTransfer(data) {
            this.activeCallTransfer = false;

            try {
                const response = await this.$store.dispatch('setCallTransfer', data);

                if (response?.data?.success) {
                    this.activeCallWaiting = response.data.success;
                    this.activeCallTransfer = !response.data.success;
                } else {
                    this.activeCallTransfer = true;
                }
            } catch (e) {
                this.$log.error(e, this.$options.__file, 'handleCallTransfer');
            }
        },

        handleChangeConferenceCallingStatus() {
            if (this.isDisabledConferenceCallingButton || this.isConferenceCallCapacityReached)
                return;

            this.activeConferenceCalling = !this.activeConferenceCalling;
        },

        async handleConferenceCalling(inboxOrContact, type) {
            this.activeConferenceCalling = false;
            if (!this.conferenceCallingParticipants.length) {
                this.conferenceCallingParticipants.push({
                    contact: this.contactToCallWidget,
                    status: '',
                    label: `contact_id:${this.contactToCallWidget.id}`,
                });
            }

            let payload;

            if (this.isConferenceCallingCreated) {
                payload = {
                    currentInboxId: this.contactFromCallWidget.id,
                    conferenceName: this.conferenceName,
                    conferenceSid: this.conferenceSid,
                };

                if (type === 'inbox') {
                    Object.assign(payload, { inboxId: inboxOrContact.id });
                }

                if (type === 'contact') {
                    Object.assign(payload, { contactId: inboxOrContact.id });
                }

                if (type === 'number') {
                    Object.assign(payload, { number: inboxOrContact.number });
                }
            } else {
                payload = {
                    labelFrom: `inbox_id:${this.contactFromCallWidget.id}`,
                    labelTo: `contact_id:${this.contactToCallWidget.id}`,
                    currentInboxId: this.contactFromCallWidget.id,
                };

                if (type === 'inbox') {
                    Object.assign(payload, { inboxId: inboxOrContact.id });
                }

                if (type === 'contact') {
                    Object.assign(payload, { contactId: inboxOrContact.id });
                }

                if (type === 'number') {
                    Object.assign(payload, { number: inboxOrContact.number });
                }
            }

            if (this.isConferenceCallingCreated) {
                this.setConferenceCallingParticipants(inboxOrContact, type);
                await this.$store.dispatch('addParticipantToConferenceCalling', payload);

                return;
            }

            this.setConferenceCallingParticipants(inboxOrContact, type);
            await this.$store.dispatch('createConferenceCalling', payload);
        },

        setConferenceCallingParticipants(data, type) {
            const participant = {
                status: 'calling',
            };

            if (type === 'inbox') {
                Object.assign(participant, { inbox: data }, { label: `inbox_id:${data.id}` });
                this.conferenceCallingParticipants.push(participant);

                return;
            }

            if (type === 'contact') {
                Object.assign(participant, { contact: data }, { label: `contact_id:${data.id}` });
                this.conferenceCallingParticipants.push(participant);

                return;
            }

            Object.assign(participant, { number: data }, { label: `number:${data}` });
            this.conferenceCallingParticipants.push(participant);
        },

        handleSelectInboxOrContact(data, type) {
            if (this.activeCallTransfer) {
                const currentInbox = {
                    callSid: window.connect.parameters.CallSid,
                    inboxId: data.id,
                };

                this.handleCallTransfer(currentInbox);

                return;
            }

            if (this.activeConferenceCalling) {
                this.handleConferenceCalling(data, type);
            }
        },

        handleCallWidgetSearchToNumber() {
            const number = `+1${this.form.search.replace(/[^0-9]/g, '')}`;
            if (this.activeCallTransfer) {
                this.handleCallTransfer({
                    callSid: window.connect.parameters.CallSid,
                    number: number,
                });

                return;
            }

            if (this.activeConferenceCalling) {
                this.handleConferenceCalling(
                    {
                        number: number,
                        formattedNumber: this.formattedNumber(
                            this.form.search.replace(/[^0-9]/g, '')
                        ),
                    },
                    'number'
                );
            }
        },

        getPhones(teams) {
            const teamsIds = teams.map((item) => item.id);
            const inboxes = this.inboxesArray.filter((item) => teamsIds.includes(item.id));
            const result = [];

            inboxes.forEach((item) => {
                if (item.numbers) {
                    item.numbers.forEach((el) => {
                        result.push(el);
                    });
                } else {
                    result.push(item.number);
                }
            });

            return result;
        },

        isValidNumber(phone) {
            if (!this.hasInboxes && !this.hasContacts) {
                const formattedNumber = typeof phone === 'string' ? phone : '';

                if (formattedNumber?.length < 10) return false;

                const phoneInfo = parsePhoneNumber(formattedNumber, 'US');

                return phoneInfo.isValid();
            }
        },

        formattedNumber(number) {
            // (999) 999-9999
            return `(${number.slice(0, 3)}) ${number.slice(3, 6)}-${number.slice(6, 10)}`;
        },

        updateParticipants(participant, status) {
            const currentLabelData = this.parseLabel(participant.label);
            this.conferenceCallingParticipants = this.conferenceCallingParticipants.map((item) => {
                const innerLabelData = this.parseLabel(item.label);
                if (
                    currentLabelData.key === innerLabelData.key &&
                    currentLabelData.value === innerLabelData.value
                ) {
                    const updatedParticipant = {
                        status: status,
                        label: item.label,
                    };

                    if (item.hasOwnProperty('contact')) {
                        Object.assign(updatedParticipant, { contact: item.contact });
                        return updatedParticipant;
                    }

                    if (item.hasOwnProperty('inbox')) {
                        Object.assign(updatedParticipant, { inbox: item.inbox });
                        return updatedParticipant;
                    }

                    if (item.hasOwnProperty('number')) {
                        Object.assign(updatedParticipant, { number: item.number });
                        return updatedParticipant;
                    }
                }

                return item;
            });
        },

        async handleChangeParticipantStatus(participant) {
            if (['loading', 'calling'].includes(participant.status) || this.isHoldConferenceCalling)
                return;

            this.updateParticipants(participant, 'loading');

            const actionType = ['', 'participant-join', 'return'].includes(participant.status)
                ? 'hold'
                : 'return';
            try {
                await this.$store
                    .dispatch('setConferenceCallingParticipantAction', {
                        conferenceSid: this.conferenceSid,
                        actionType: actionType,
                        participantLabel: participant.label,
                    })
                    .then((response) => {
                        if (response && actionType) {
                            this.updateParticipants(participant, actionType);
                        } else {
                            this.updateParticipants(participant, 'participant-join');
                        }
                    });
            } catch (e) {
                this.updateParticipants(participant, 'participant-join');
                this.$log.error(e, this.$options.__file, 'handleChangeParticipantStatus');
            }
        },

        async handleParticipantCallEnd(participant) {
            this.updateParticipants(participant, 'deletion');

            try {
                await this.$store
                    .dispatch('setConferenceCallingParticipantAction', {
                        conferenceSid: this.conferenceSid,
                        actionType: 'remove',
                        participantLabel: participant.label,
                    })
                    .then((response) => {
                        if (response) {
                            this.conferenceCallingParticipants =
                                this.conferenceCallingParticipants.filter(
                                    (item) => item.label !== participant.label
                                );
                        } else {
                            this.updateParticipants(participant, 'participant-join');
                        }
                    });
            } catch (e) {
                this.updateParticipants(participant, 'participant-join');
                this.$log.error(e, this.$options.__file, 'handleParticipantCallEnd');
            }
        },

        handleShowAllInboxes() {
            this.isClickedButtonMoreInboxes = true;
        },

        handleShowAllContacts() {
            this.isClickedButtonMoreContacts = true;
        },

        parseLabel(label) {
            const data = label.split(':');

            return {
                key: data[0],
                value: data[1],
            };
        },

        reset() {
            this.$store.dispatch('resetConferenceCallingStatus');
            this.showRollup = false;
            this.activeMute = false;
            this.activeRecord = false;
            this.activeKeypad = false;
            this.activeIncomingMute = false;
            this.activeReplay = false;
            this.replayMessage = '';
            this.messageSent = false;
            this.activeCallWaiting = true;
            this.activeCallTransfer = false;
            this.activeConferenceCalling = false;
            this.form.inboxId = null;
            this.form.search = '';
            this.form.smartInboxNumber = 0;
            this.form.holdCount = 0;
            this.busy = false;
            this.active = false;
            this.searchResult = null;
            this.conferenceCallingParticipants = [];
            this.isClickedButtonMoreInboxes = false;
            this.isClickedButtonMoreContacts = false;
            this.isCancelClicked = false;
        },

        handleShowCancelButtons() {
            if (this.loadingCallEnd || this.isCancelClicked) return;

            this.isShowCancelButtons = !this.isShowCancelButtons;
        },
    },

    unmounted() {
        this.reset();
    },

    async mounted() {
        this.init();
        this.activeRecord = this.twilioRecord;
    },
};
</script>
